import TableComponent from '../../../_metronic/partials/UserComponents/TableComponent'

import React from 'react'

const User = () => {
  return (
    <>
      <div className='row gx-5 gx-xl-10'>
        {/* begin::Col */}
        <TableComponent className='card-xxl-stretch mb-5 mb-xl-8' />
        {/* end::Col */}
      </div>
    </>
  )
}

export default User
